import { Swiper, SwiperSlide } from "swiper/react";

import { Models } from "@/api/types";
import { notFalsy } from "@/toolbox/Guards";

import "swiper/css";

interface ProductSliderProps {
  listings: Models<"ListingModel">[];
  onItemClick?: (listing: Models<"ListingModel">) => void;
}

export const ProductSlider = ({
  listings,
  onItemClick,
}: ProductSliderProps) => {
  const validListings = listings
    ?.filter(
      (listing) =>
        listing.type !== "Product" &&
        listing.type !== "ProductFromExternalSource" &&
        listing.imageUrl &&
        listing.title
    )
    .filter(notFalsy);

  if (!validListings || validListings.length === 0) {
    return null;
  }

  return (
    <div className="-mx-8 overflow-hidden">
      <Swiper
        className="!px-8"
        slidesPerView="auto"
        spaceBetween={24} // 24px = gap-6
        freeMode={true}
        grabCursor={true}
      >
        {validListings
          .filter((listing) => listing.imageUrl && listing.title)
          .map((listing) => {
            const handleClick = () => {
              onItemClick?.(listing);
            };

            return (
              <SwiperSlide
                key={listing.id}
                className="!w-auto cursor-pointer pb-4"
                onClick={handleClick}
              >
                <ProductSliderItem listing={listing} />
              </SwiperSlide>
            );
          })}
      </Swiper>
    </div>
  );
};

export const ProductSliderItem = ({
  listing,
}: {
  listing: Models<"ListingModel">;
}) => {
  return (
    <div>
      {/* Image with fixed height and auto width based on 4/3 aspect ratio */}
      <div className="overflow-hidden rounded-t-lg shadow-subtle">
        <img
          src={listing.imageUrl!}
          alt={listing.title}
          className="aspect-[4/3] h-40 w-auto object-cover"
        />
      </div>

      {/* Title card */}
      <div
        className="w-full rounded-b-lg bg-white/30 px-4
      py-3 shadow-subtle ring-1
      ring-white/60 backdrop-blur-xl"
        style={{ width: "calc(160px * 4 / 3)" }} // Match image width
      >
        <h3 className="truncate font-serif text-h3 text-nearly-black">
          {listing.title}
        </h3>
      </div>
    </div>
  );
};
